import * as React from 'react';

import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import Frame from 'bundles/widget-simulator/components/browser/Frame';
import Toolbar from 'bundles/widget-simulator/components/browser/Toolbar';
import type WidgetSimulatorStoreClass from 'bundles/widget-simulator/stores/WidgetSimulatorStore';

import 'css!./__styles__/Browser';

type PropsFromCaller = {};

type PropsFromStores = {
  showFrame: boolean;
  isSessionLoaded: boolean;
};

type PropsToComponent = PropsFromCaller & PropsFromStores;

const Browser = (props: PropsToComponent) => {
  const { isSessionLoaded, showFrame } = props;

  return (
    <div className="rc-Browser">
      <Toolbar />
      {isSessionLoaded && showFrame && <Frame />}
    </div>
  );
};

type Stores = {
  WidgetSimulatorStore: typeof WidgetSimulatorStoreClass;
};

export default compose<PropsToComponent, PropsFromCaller>(
  connectToStores<PropsFromStores, {}, Stores>(['WidgetSimulatorStore'], ({ WidgetSimulatorStore }) => ({
    isSessionLoaded: WidgetSimulatorStore.getIsSessionLoaded(),
    showFrame: WidgetSimulatorStore.shouldShowFrame(),
  }))
)(Browser);
